import {PhonesComponent} from '../phones/phones.component';
import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {IClinicBranch} from '../../models/clinic-branch';
import {timeZonesData} from '../../config/data/time-zones/time-zones.data';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {AddressSectionComponent} from '../address-section/address-section.component';
import {NgForm} from '@angular/forms';
import {HelperValidationField} from '../../class/helper/helper-validation-field.class';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {IScheduleGroup, TimetableState} from '../../models/timetable';
import {Observable} from 'rxjs';
import {Store} from '@ngxs/store';
import {cloneDeep} from 'lodash';

@Component({
  selector: 'app-modal-create-branch',
  templateUrl: './modal-create-branch.component.html',
  styleUrls: ['./modal-create-branch.component.scss'],
  animations: [fadeInAnimation]
})
export class ModalCreateBranchComponent implements OnInit, OnChanges {
  @Input() clinicBranch: IClinicBranch;
  @Input() defaultScheduleGroupIdOfClinic: string;
  // Modal actions
  @Input() isVisibleModal: boolean;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('clinicBranchForm') clinicBranchForm: NgForm;
  @ViewChild(PhonesComponent) phonesComponent: PhonesComponent;
  @ViewChild(AddressSectionComponent) addressSectionComponent: AddressSectionComponent;
  helperValidationField: HelperValidationField;
  timeZones: string[];
   scheduleGroups$: Observable<IScheduleGroup[]> = this.store.select<IScheduleGroup[]>(TimetableState.getScheduleGroups);
  constructor(
    private utilitiesService: UtilitiesService,
    private store: Store
  ) { }

  ngOnInit(): void {
    this.helperValidationField = new HelperValidationField();
    this.checkClinicBranch();
    this.timeZones = timeZonesData.nameTimeZones();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isVisibleModal?.currentValue === false) {
      this.checkClinicBranch();
    }
  }

  onCloseModal(emit: boolean): void {
    this.closeModal.emit(emit);
  }

  /**
   * Touch all forms
   */
  formMarkAllAsTouched(): void {
    this.clinicBranchForm.form.markAllAsTouched();
    this.addressSectionComponent?.formAddress?.form?.markAllAsTouched();
    this.phonesComponent.isValid();
  }

  /**
   * Check that forms clinicBranchForm, phoneSectionComponent and addressSectionComponent are valid
   * @return boolean
   */
  areValidForms(): boolean {
    return (this.clinicBranchForm.valid &&
      this.addressSectionComponent?.formAddress?.valid &&
      this.phonesComponent.isValid());
  }

  /**
   * Get clinicBranch values
   * @return IClinicBranch
   * @note need to add the clinicId property externally
   */
  getValue(): IClinicBranch {
    return {
      ...this.clinicBranchForm.form.value,
      address: this.addressSectionComponent?.formAddress?.value,
      phones: this.phonesComponent.getRawValue(),
    };
  }

  /**
   * Check obj clinicBranch
   * @private
   */
  private checkClinicBranch(): void {
    this.clinicBranch = cloneDeep(this.clinicBranch ?? {
      name: '',
      email: '',
      clinicId: '',
      timeZone: this.utilitiesService.getTimeZoneBrowser(),
      scheduleGroupId: this.defaultScheduleGroupIdOfClinic, // el horario por defecto de la clinica
      address: {
        country: '',
        reference: '',
        state: '',
        street: '',
        cp: '',
        suburb: '',
        city: ''
      }
    });
  }

}
